

export const headerData = {
    name: 'Genise Butler',
    pageTitle: "Genise's Pieces",
    title: "Digital Designer",
    desciption:"I love turning ideas into clean, creative visuals. With a sharp eye for detail and a passion for storytelling, I build designs that are not just good-looking but also user-friendly and on-brand. Whether it’s a sleek website or a bold brand identity, I’m all about helping businesses stand out online with smart, thoughtful design.",
    image: 'https://avatars.githubusercontent.com/u/197447081?v=4',
    resumePdf: '/resume.pdf',
}
